export const ServiceNameKeys = {
  subscribeToMonthly: 'subscribe_to_monthly_plan',
  subscribeToAnnual: 'subscribe_to_annual_plan',
  subscribeToAllInclusiveAnnual: 'subscribe_to_all_inclusive_annual_plan',
  subscriptionPlanMonthly: 'subscription_plan_monthly',
  subscriptionPlanAnnual: 'subscription_plan_annual',
  subscriptionPlanAnnualAllInclusive: 'subscription_plan_annual_all_inclusive',
  // The Monthly plan's month 12, paid at the first visit (consumer skin,
  // Aperio): a booked line the server adds (consumer-booking/monthly-prepay).
  subscriptionPlanMonthlyLastMonthPrepaid:
  'subscription_plan_monthly_last_month_prepaid',
  oilChangeBasic: 'oil_change_basic',
  oilChangePremiumSynthetic: 'oil_change_premium_synthetic',
  oilChangeEuropeanSynthetic: 'oil_change_european_synthetic',
  engineAirFilterReplacement: 'engine_air_filter_replacement',
  cabinAirFilterReplacement: 'cabin_air_filter_replacement',
  tireRotation: 'tire_rotation',
  seasonalSwap: 'seasonal_swap',
  tireChange: 'tire_change',
  priorityServiceFee: 'priority_service_fee',
  suppliesAndShopFee: 'supplies_and_shop_fee',
  environmentalHandlingFee: 'environmental_handling_fee',
  mobileServiceFee: 'mobile_service_fee',
  mobileServiceFeeSubscription: 'mobile_service_fee_subscription',
  mobileServiceFeeAllInclusiveSubscription:
  'mobile_service_fee_all_inclusive_subscription',
  mobileServiceFeeAMZ: 'mobile_service_fee_amazon',
  mobileServiceFeeAMZMainService: 'mobile_service_fee_amazon_main_service',
  tax: 'tax',
  mileageCharge: 'mileage_charge',
  uBoltRetorque: 'u_bolt_retorque',
} as const;

export type ServiceNameKey =
typeof ServiceNameKeys[keyof typeof ServiceNameKeys];

export const isSubscribeTo = (
  k?: string | null,
): boolean => k === ServiceNameKeys.subscribeToMonthly
|| k === ServiceNameKeys.subscribeToAnnual
|| k === ServiceNameKeys.subscribeToAllInclusiveAnnual;

export const isSubscriptionPlan = (
  k?: string | null,
): boolean => k === ServiceNameKeys.subscriptionPlanMonthly
|| k === ServiceNameKeys.subscriptionPlanAnnual;

/** Pair keys:
 *  subscribe_to_monthly_plan  ↔ subscription_plan_monthly
 *  subscribe_to_annual_plan   ↔ subscription_plan_annual
 */
export const pairedKey = (k?: string | null): ServiceNameKey | null => {
  switch (k) {
    case ServiceNameKeys.subscribeToMonthly:
      return ServiceNameKeys.subscriptionPlanMonthly;
    case ServiceNameKeys.subscribeToAnnual:
      return ServiceNameKeys.subscriptionPlanAnnual;
    case ServiceNameKeys.subscribeToAllInclusiveAnnual:
      return ServiceNameKeys.subscriptionPlanAnnualAllInclusive;
    default: return null;
  }
};

export const isServiceNameKey = (k: unknown): k is ServiceNameKey => typeof k
=== 'string'
  && (Object.values(ServiceNameKeys) as readonly string[]).includes(k);
